module.exports = {
  defaultTitle: 'Blockboard',
  logo: 'https://www.blockboard.tech/favicon/favicon-512.png',
  author: 'Blockboard',
  url: 'https://www.blockboard.tech/',
  legalName: 'Blockboard',
  defaultDescription: 'Building Decentralized Applications on the Blockchain.',
  socialLinks: {
    twitter: 'http://www.twitter.com/smakosh',
    github: 'https://github.com/blockboard',
    linkedin: 'https://www.linkedin.com/company/block-board/',
    instagram: 'https://instagram.com/smakosh19',
    youtube: 'https://www.youtube.com/user/smakoshthegamer',
    google: 'https://plus.google.com/u/0/+IsmailSmakoshGhallou',
  },
  googleAnalyticsID: 'UA-88875900-4',
  themeColor: '#6b63ff',
  backgroundColor: '#6b63ff',
  social: {
    facebook: 'appId',
    twitter: '@smakosh',
  },
  address: {
    city: 'City',
    region: 'Region',
    country: 'Country',
    zipCode: 'ZipCode',
  },
  contact: {
    email: 'email',
    phone: 'phone number',
  },
  foundingDate: '2018',
};
